import api from './api';
import { IDocumentTemplate } from '../types/document';

export const documentTemplateService = {
  // Get all document templates
  getDocumentTemplates: async (): Promise<IDocumentTemplate[]> => {
    const response = await api.get<IDocumentTemplate[]>('/document-templates');
    return response.data;
  },

  // Get uploaded templates for estate lawyers
  getUploadedTemplates: async (): Promise<IDocumentTemplate[]> => {
    const response = await api.get<IDocumentTemplate[]>('/document-templates?templateKind=uploaded_document');
    return response.data;
  },

  // Get a single template by ID
  getTemplateById: async (id: string): Promise<IDocumentTemplate> => {
    const response = await api.get<IDocumentTemplate>(`/document-templates/${id}`);
    return response.data;
  },

  // Upload a reusable PDF template
  uploadTemplatePdf: async (file: File, title?: string, idempotencyKey?: string) => {
    const formData = new FormData();
    formData.append('file', file);
    if (title) formData.append('title', title);
    const headers: Record<string, string> = {};
    if (idempotencyKey) headers['idempotency-key'] = idempotencyKey;

    const response = await api.post('/document-templates/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...headers,
      },
    });
    return response.data;
  },

  // Fetch source PDF blob for previewing/viewing
  getSourcePdfBlob: async (id: string): Promise<Blob> => {
    const response = await api.get<Blob>(`/document-templates/${id}/source-file`, {
      responseType: 'blob',
    });
    return response.data;
  },

  // Retry a failed import job
  retryImport: async (importId: string) => {
    const response = await api.post(`/document-imports/${importId}/retry`);
    return response.data;
  },

  // Get import status for polling
  getImportStatus: async (importId: string) => {
    const response = await api.get<{ import: any }>(`/document-imports/${importId}`);
    return response.data;
  },

  // Update reusable template metadata/content
  updateTemplate: async (id: string, data: Partial<IDocumentTemplate>): Promise<IDocumentTemplate> => {
    const response = await api.patch<IDocumentTemplate>(`/document-templates/${id}`, data);
    return response.data;
  },
};
